<template>
    <v-col cols="12" sm="12">

        <div style="display: flex; align-items: center; gap: 6px" class="input__group" :id="anchorId">
            <div>
                {{ label }}
            </div>
            <div class="horizontal__line"></div>

            <label class="agent-classification-label">
                {{ classificationLabel }}
            </label>
        </div>
    </v-col>

</template>

<script>
export default {
    name: "AgentClassificationLabelComponent",
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
        /** Field caption — the same read-only row renders both classification pools. */
        label: {
            type: String,
            default: "تصنيف الاستشارى",
        },
        /** DOM anchor used by the field-log scroll targets; must stay unique per page. */
        anchorId: {
            type: String,
            default: "class_agent",
        },
        /** Optional: use API text directly when store list may not include agent classes (CS pages) */
        text: {
            type: String,
            default: "",
        },
        fallback: {
            type: String,
            default: "لم يتم تصنيف الاستشارى",
        },
    },
    computed: {
        classificationLabel() {
            if (this.text) {
                return this.text;
            }
            if (this.id == null || this.id === "") {
                return this.fallback;
            }
            const pools = [
                this.$store.state.agent_request_class,
                this.$store.state.request_class,
                this.$store.state.cs_request_class,
            ];
            for (const pool of pools) {
                const match = (pool || []).find(
                    (el) => String(el.id) === String(this.id)
                );
                if (match?.value) {
                    return match.value;
                }
            }
            return this.fallback;
        },
    },
};
</script>

<style scoped>
.agent-classification-label {
    font-size: 14px;
    font-weight: 600;
    color: #2c2c2c;
}
</style>

<style>
.dark .agent-classification-label {
    color: #f3f5f7 !important;
}
</style>
